import React from 'react';
import {
    Responsive,
    SimpleList,
    Datagrid,
    TextField,
} from 'admin-on-rest';
import List from '../admin/List';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/shop';

export const fuseLoyaltyAccountTransactionIcon = Icon;

/*
 * View: List
 */

// Set title for List Customer Transactions
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                                className="avatar-title"/>Customer Transactions</span>;

const ListDescription = () => {
    return (
        <span>
            <p>Review the transactions by this Loyalty Account Customer.</p>
        </span>
    );
};

export const fuseLoyaltyAccountTransactionList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} sort={{field: 'uuid', order: 'ASC'}} perPage={100}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => 'Location ' + record.uuid}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="uuid" label="ID"/>
                </Datagrid>
            }
            large={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="uuid" label="ID"/>
                </Datagrid>
            }
        />
    </List>
);



// WEBPACK FOOTER //
// ./src/Fuse/Loyalty/transaction.js